var symphony = symphony || {};

;(function() {
	
	symphony.stickyNav = function() {

		var $globalHeader = $('.globalHeader');
		var $window = $(window);
		var $givingToolbar = $('.givingToolbar-toolbar');
		var $windowHeight = $(window).outerHeight();
		var $globalHeaderHeight = $('.globalHeader').outerHeight();
		var $givingToolbarHeight = $givingToolbar.outerHeight();
		var heroContainer = $('.heroContainer').outerHeight();
		var localName = $('.localName');

		function stickGivingToolbar(){
			var scroll = $window.scrollTop();
			console.log(scroll);
			console.log($windowHeight - ($globalHeaderHeight + $givingToolbarHeight));
			if (scroll > heroContainer) {
				$givingToolbar.addClass('navbar-fixed');
			} else {
				$givingToolbar.removeClass('navbar-fixed');
			}
		}

		if($('.heroContainer').length <= 0){
			$globalHeader.addClass('isSticky');
			return;
		}

		if($('.localSite').length > 0){
			//$window.on('scroll', _.throttle(stickGivingToolbar, 50));

			if($('.localSite.home').length <= 0 && $('.localSite.ministry').length <= 0){
				$globalHeader.addClass('isSticky');
				return;
			}
		}
		
		var tries = 0;
		function setWaypoint() {
			if ($('.section').length > 0) {
				var makeOpaque = new Waypoint({
					element: $('.section')[0],
					handler: function(direction) {
						$globalHeader.addClass('isSticky');
						$givingToolbar.addClass('navbar-fixed');
						if(localName.length > 0){
							localName.addClass('no-padding-top');
						}
					}
				});
			}
			else if (tries < 3) {
				setTimeout(function() { setWaypoint(); }, 1000);
				tries++;
			}
		}

		function resetNav(){
			var scroll = $window.scrollTop();
			if(scroll <= 100) {
				if(!symphony.config.utilities.expandingHeader.hasClass('isExpanded')){
				  $globalHeader.removeClass('isSticky');
				  $givingToolbar.removeClass('navbar-fixed');
				  if(localName.length > 0){
						localName.removeClass('no-padding-top');
					}
				}
			}
		}

		$window.on('scroll', _.throttle(resetNav, 50));

		setWaypoint();
		
		

	};


})();